module.exports = "<vue-component class=\"tr-page__wrapper\" component=\"UserMap\" v-props=\"currentParams\"></vue-component>"